// This icon file is generated automatically.
var PFileExcelOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.35 3.5L9 .16A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .6H8.4V1.14l2.94 2.94zm.03 8.78H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71zM7.03 8.05l-.96-1.6a.19.19 0 00-.16-.09h-.6c-.04 0-.07.01-.1.03a.19.19 0 00-.06.26L6.43 8.7l-1.3 2.08a.19.19 0 00.16.29h.54c.07 0 .12-.04.16-.1l.98-1.58.97 1.58c.04.06.1.1.16.1h.59a.19.19 0 00.16-.29L7.53 8.72l1.34-2.07a.19.19 0 00-.16-.29h-.56a.19.19 0 00-.16.1l-.96 1.6z", "fill-rule": "nonzero" } }] }, "name": "p-file-excel", "theme": "outlined" };
export default PFileExcelOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileExcelOutlined.js
// module id = 3382
// module chunks = 0